import { all, takeLatest } from "redux-saga/effects";
import {
  REFUND_REQUEST_LIST,
  APPROVE_REFUND_REQUEST,
} from "../actions/refund-request.actions.types";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";

const call = Effects.call;

function* getRefundRequestList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "refund-requests",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* approveRefundRequest({ payload: { id, callback } }) {
  const payload = {
    method: "post",
    url: `refund-requests/approve/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* RefundRequest() {
  yield all([
    takeLatest(REFUND_REQUEST_LIST, getRefundRequestList),
    takeLatest(APPROVE_REFUND_REQUEST, approveRefundRequest),
  ]);
}

export default RefundRequest;
